import React, { createContext, useRef, useState } from "react";

const defaultState = {};

const AppContext = createContext(defaultState);

const AppProvider = ({ children }) => {
  const [uuid, setUuid] = useState(null);
  const headerRef = useRef(null);
  const stickyIsiRef = useRef(null);
  const isiRef = useRef(null);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [exitUrl, setExitUrl] = useState("");
  const [modalType, setModalType] = useState("");

  const openModal = (url, type = "exit") => {
    setExitUrl(url);
    setShowModal(true);
    setModalType(type);
  };

  const openExitModal = (url) => {
    openModal(url, "exit");
  };

  const closeModal = () => {
    setShowModal(false);

    // bug fix: prevent the modal from closing before the exit URL is opened
    // without this, the exit url clears too fast, and the browser opens a tab with the same url instead of the exit one
    setTimeout(() => {
      setExitUrl("");
    }, 100);

    setModalType("");
  };

  const store = {
    uuid,
    setUuid,
    headerRef,
    stickyIsiRef,
    isiRef,
    isHeaderVisible,
    setIsHeaderVisible,
    showModal,
    setShowModal,
    exitUrl,
    openModal,
    openExitModal,
    modalType,
    setModalType,
    closeModal,
  };

  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};

export default AppContext;

export { AppProvider };
